<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12">
        <div class="nav-tabs-custom no-margin">
          <ul class="nav nav-tabs">
            <li class="active">
              <a href="#settings" data-toggle="tab" aria-expanded="false">{{ 'general-settings' | translate }}</a>
            </li>
          </ul>
        </div>
        <div class="tab-content">
          <div class="tab-pane active" id="settings">
            <div class="row">
              <div class="col-xs-12">
                <div class="box box-primary">
                  <div class="box-body">
                    <h5 class="mb-10">
                      <i class="fa fa-cogs text-muted mr-5"></i>{{ 'document_settings' | translate }}:
                    </h5>
                    <div class="row">
                      <div class="col-sm-12 col-lg-7">
                        <StoreLogoUploader />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import StoreLogoUploader from '../../tools/StoreLogoUploader.vue'

export default {
  name: 'GeneralSettingsView',
  components: {StoreLogoUploader}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Directsale/GeneralSettingsView.vue